/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DashboardAddUserToFederation,
  DashboardCreateUser,
  DashboardCurrentUser,
  DashboardMergeUsers,
  DashboardMergeUsersResult,
  DashboardUpdateUser,
  DashboardUserDetail,
  DashboardUserList,
  DashboardUserRef,
  DashboardUserSearchResult,
  DashboardUsersControllerAddToFederation400,
  DashboardUsersControllerAddToFederation401,
  DashboardUsersControllerAddToFederation403,
  DashboardUsersControllerAddToFederation404,
  DashboardUsersControllerAddToFederation429,
  DashboardUsersControllerCreate400,
  DashboardUsersControllerCreate401,
  DashboardUsersControllerCreate409,
  DashboardUsersControllerCreate429,
  DashboardUsersControllerDetail400,
  DashboardUsersControllerDetail401,
  DashboardUsersControllerDetail404,
  DashboardUsersControllerDetail429,
  DashboardUsersControllerExport400,
  DashboardUsersControllerExport401,
  DashboardUsersControllerExport413,
  DashboardUsersControllerExport429,
  DashboardUsersControllerExportParams,
  DashboardUsersControllerList400,
  DashboardUsersControllerList401,
  DashboardUsersControllerList429,
  DashboardUsersControllerListParams,
  DashboardUsersControllerLookup400,
  DashboardUsersControllerLookup401,
  DashboardUsersControllerLookup404,
  DashboardUsersControllerLookup429,
  DashboardUsersControllerLookupParams,
  DashboardUsersControllerMe400,
  DashboardUsersControllerMe401,
  DashboardUsersControllerMe404,
  DashboardUsersControllerMe429,
  DashboardUsersControllerMerge400,
  DashboardUsersControllerMerge401,
  DashboardUsersControllerMerge403,
  DashboardUsersControllerMerge404,
  DashboardUsersControllerMerge409,
  DashboardUsersControllerMerge429,
  DashboardUsersControllerRefs400,
  DashboardUsersControllerRefs401,
  DashboardUsersControllerRefs429,
  DashboardUsersControllerRefsParams,
  DashboardUsersControllerSearch400,
  DashboardUsersControllerSearch401,
  DashboardUsersControllerSearch429,
  DashboardUsersControllerSearchParams,
  DashboardUsersControllerUpdate400,
  DashboardUsersControllerUpdate401,
  DashboardUsersControllerUpdate404,
  DashboardUsersControllerUpdate409,
  DashboardUsersControllerUpdate429,
} from ".././schemas";
import { restClient } from "../../restClient";
import type { ErrorType, BodyType } from "../../restClient";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Paginated user list scoped to the caller: the `USER:READ` capability universe UNION the legacy accessible sets. `platformIds` and `federationIds` are pure filters applied together (AND of axes); the platform filter reads the authoritative `(user, federation, platform)` membership pivot — a membership with no platform attribution counts as a wildcard over the platforms its federation is linked to. Requesting an out-of-scope id yields a narrowed (possibly empty) page, never a 403. Mirrors the legacy `userList` GraphQL query but returns only the fields used by the dashboard Users page.
 * @summary List users (dashboard)
 */
export const dashboardUsersControllerList = (
  params?: DashboardUsersControllerListParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardUserList>(
    { url: `/api/dashboard/v1/users`, method: "GET", params, signal },
    options
  );
};

export const getDashboardUsersControllerListQueryKey = (
  params?: DashboardUsersControllerListParams
) => {
  return [`/api/dashboard/v1/users`, ...(params ? [params] : [])] as const;
};

export const getDashboardUsersControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardUsersControllerList>>,
  TError = ErrorType<
    | DashboardUsersControllerList400
    | DashboardUsersControllerList401
    | DashboardUsersControllerList429
  >,
>(
  params?: DashboardUsersControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardUsersControllerListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardUsersControllerList>>> = ({
    signal,
  }) => dashboardUsersControllerList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardUsersControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardUsersControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardUsersControllerList>>
>;
export type DashboardUsersControllerListQueryError = ErrorType<
  | DashboardUsersControllerList400
  | DashboardUsersControllerList401
  | DashboardUsersControllerList429
>;

export function useDashboardUsersControllerList<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerList>>,
  TError = ErrorType<
    | DashboardUsersControllerList400
    | DashboardUsersControllerList401
    | DashboardUsersControllerList429
  >,
>(
  params: undefined | DashboardUsersControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardUsersControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardUsersControllerList<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerList>>,
  TError = ErrorType<
    | DashboardUsersControllerList400
    | DashboardUsersControllerList401
    | DashboardUsersControllerList429
  >,
>(
  params?: DashboardUsersControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardUsersControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardUsersControllerList<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerList>>,
  TError = ErrorType<
    | DashboardUsersControllerList400
    | DashboardUsersControllerList401
    | DashboardUsersControllerList429
  >,
>(
  params?: DashboardUsersControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List users (dashboard)
 */

export function useDashboardUsersControllerList<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerList>>,
  TError = ErrorType<
    | DashboardUsersControllerList400
    | DashboardUsersControllerList401
    | DashboardUsersControllerList429
  >,
>(
  params?: DashboardUsersControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardUsersControllerListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new user. The caller must have access to every federation in `federationIds`. Returns the same shape as `GET /users/:id` so the FE can populate the edit page without a follow-up request.
 * @summary Create user (dashboard)
 */
export const dashboardUsersControllerCreate = (
  dashboardCreateUser: BodyType<DashboardCreateUser>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardUserDetail>(
    {
      url: `/api/dashboard/v1/users`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardCreateUser,
      signal,
    },
    options
  );
};

export const getDashboardUsersControllerCreateMutationOptions = <
  TError = ErrorType<
    | DashboardUsersControllerCreate400
    | DashboardUsersControllerCreate401
    | DashboardUsersControllerCreate409
    | DashboardUsersControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardUsersControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateUser> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardUsersControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateUser> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardUsersControllerCreate>>,
    { data: BodyType<DashboardCreateUser> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardUsersControllerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardUsersControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardUsersControllerCreate>>
>;
export type DashboardUsersControllerCreateMutationBody = BodyType<DashboardCreateUser>;
export type DashboardUsersControllerCreateMutationError = ErrorType<
  | DashboardUsersControllerCreate400
  | DashboardUsersControllerCreate401
  | DashboardUsersControllerCreate409
  | DashboardUsersControllerCreate429
>;

/**
 * @summary Create user (dashboard)
 */
export const useDashboardUsersControllerCreate = <
  TError = ErrorType<
    | DashboardUsersControllerCreate400
    | DashboardUsersControllerCreate401
    | DashboardUsersControllerCreate409
    | DashboardUsersControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardUsersControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateUser> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardUsersControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateUser> },
  TContext
> => {
  const mutationOptions = getDashboardUsersControllerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Paginated autocomplete-friendly user search. Returns the shared user-ref shape (id, name, surname, avatar) for dashboard pickers, wrapped in the standard pagination envelope so the FE can drive an infinite-scroll dropdown. Fuzzy and typo-tolerant: matches against name, surname, full name (`name surname`), email, and phone — a multi-word keyword like "John Doe" resolves the right user, and a single-character typo still surfaces them. A keyword that exactly equals a user's DUPR id (case-insensitive, e.g. `W6MR9M`) surfaces that user. A purely numeric keyword short-circuits to an exact id lookup. Scoped identically to the user list: a caller cannot enumerate users in scopes they cannot see in the list.
 * @summary Search users (dashboard)
 */
export const dashboardUsersControllerSearch = (
  params?: DashboardUsersControllerSearchParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardUserSearchResult>(
    { url: `/api/dashboard/v1/users/search`, method: "GET", params, signal },
    options
  );
};

export const getDashboardUsersControllerSearchQueryKey = (
  params?: DashboardUsersControllerSearchParams
) => {
  return [`/api/dashboard/v1/users/search`, ...(params ? [params] : [])] as const;
};

export const getDashboardUsersControllerSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardUsersControllerSearch>>,
  TError = ErrorType<
    | DashboardUsersControllerSearch400
    | DashboardUsersControllerSearch401
    | DashboardUsersControllerSearch429
  >,
>(
  params?: DashboardUsersControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerSearch>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardUsersControllerSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardUsersControllerSearch>>> = ({
    signal,
  }) => dashboardUsersControllerSearch(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardUsersControllerSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardUsersControllerSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardUsersControllerSearch>>
>;
export type DashboardUsersControllerSearchQueryError = ErrorType<
  | DashboardUsersControllerSearch400
  | DashboardUsersControllerSearch401
  | DashboardUsersControllerSearch429
>;

export function useDashboardUsersControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerSearch>>,
  TError = ErrorType<
    | DashboardUsersControllerSearch400
    | DashboardUsersControllerSearch401
    | DashboardUsersControllerSearch429
  >,
>(
  params: undefined | DashboardUsersControllerSearchParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerSearch>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardUsersControllerSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardUsersControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerSearch>>,
  TError = ErrorType<
    | DashboardUsersControllerSearch400
    | DashboardUsersControllerSearch401
    | DashboardUsersControllerSearch429
  >,
>(
  params?: DashboardUsersControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerSearch>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardUsersControllerSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardUsersControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerSearch>>,
  TError = ErrorType<
    | DashboardUsersControllerSearch400
    | DashboardUsersControllerSearch401
    | DashboardUsersControllerSearch429
  >,
>(
  params?: DashboardUsersControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerSearch>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Search users (dashboard)
 */

export function useDashboardUsersControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerSearch>>,
  TError = ErrorType<
    | DashboardUsersControllerSearch400
    | DashboardUsersControllerSearch401
    | DashboardUsersControllerSearch429
  >,
>(
  params?: DashboardUsersControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerSearch>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardUsersControllerSearchQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Batch lookup of the shared `UserRef` shape (id / name / surname / avatar) for a known set of ids. Used to rehydrate filter-chip labels from saved client state. Order matches the request; ids the caller cannot resolve are silently omitted.
 * @summary Resolve user refs by id (dashboard)
 */
export const dashboardUsersControllerRefs = (
  params: DashboardUsersControllerRefsParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardUserRef[]>(
    { url: `/api/dashboard/v1/users/refs`, method: "GET", params, signal },
    options
  );
};

export const getDashboardUsersControllerRefsQueryKey = (
  params: DashboardUsersControllerRefsParams
) => {
  return [`/api/dashboard/v1/users/refs`, ...(params ? [params] : [])] as const;
};

export const getDashboardUsersControllerRefsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardUsersControllerRefs>>,
  TError = ErrorType<
    | DashboardUsersControllerRefs400
    | DashboardUsersControllerRefs401
    | DashboardUsersControllerRefs429
  >,
>(
  params: DashboardUsersControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardUsersControllerRefsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardUsersControllerRefs>>> = ({
    signal,
  }) => dashboardUsersControllerRefs(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardUsersControllerRefs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardUsersControllerRefsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardUsersControllerRefs>>
>;
export type DashboardUsersControllerRefsQueryError = ErrorType<
  | DashboardUsersControllerRefs400
  | DashboardUsersControllerRefs401
  | DashboardUsersControllerRefs429
>;

export function useDashboardUsersControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerRefs>>,
  TError = ErrorType<
    | DashboardUsersControllerRefs400
    | DashboardUsersControllerRefs401
    | DashboardUsersControllerRefs429
  >,
>(
  params: DashboardUsersControllerRefsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerRefs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardUsersControllerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardUsersControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerRefs>>,
  TError = ErrorType<
    | DashboardUsersControllerRefs400
    | DashboardUsersControllerRefs401
    | DashboardUsersControllerRefs429
  >,
>(
  params: DashboardUsersControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerRefs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardUsersControllerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardUsersControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerRefs>>,
  TError = ErrorType<
    | DashboardUsersControllerRefs400
    | DashboardUsersControllerRefs401
    | DashboardUsersControllerRefs429
  >,
>(
  params: DashboardUsersControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Resolve user refs by id (dashboard)
 */

export function useDashboardUsersControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerRefs>>,
  TError = ErrorType<
    | DashboardUsersControllerRefs400
    | DashboardUsersControllerRefs401
    | DashboardUsersControllerRefs429
  >,
>(
  params: DashboardUsersControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardUsersControllerRefsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Reassign every record owned by `sourceUserId` onto `targetUserId` in a single transaction. Mirrors the `mergeUsers` GraphQL mutation: federation-bound entities (purchased licenses, tournament team members, partner searches, club memberships, payment/transaction history, league rankings, league member roles) are reassigned subject to the caller's federation scope; user-bound data (sports, coach assignments, friends) and non-empty third-party IDs are always moved. Refused with 409 `MERGE_USERS_ENTRY_CONFLICT` when both accounts are active members of the same tournament entry.
 * @summary Merge two users (dashboard)
 */
export const dashboardUsersControllerMerge = (
  dashboardMergeUsers: BodyType<DashboardMergeUsers>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardMergeUsersResult>(
    {
      url: `/api/dashboard/v1/users/merge`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardMergeUsers,
      signal,
    },
    options
  );
};

export const getDashboardUsersControllerMergeMutationOptions = <
  TError = ErrorType<
    | DashboardUsersControllerMerge400
    | DashboardUsersControllerMerge401
    | DashboardUsersControllerMerge403
    | DashboardUsersControllerMerge404
    | DashboardUsersControllerMerge409
    | DashboardUsersControllerMerge429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardUsersControllerMerge>>,
    TError,
    { data: BodyType<DashboardMergeUsers> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardUsersControllerMerge>>,
  TError,
  { data: BodyType<DashboardMergeUsers> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardUsersControllerMerge>>,
    { data: BodyType<DashboardMergeUsers> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardUsersControllerMerge(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardUsersControllerMergeMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardUsersControllerMerge>>
>;
export type DashboardUsersControllerMergeMutationBody = BodyType<DashboardMergeUsers>;
export type DashboardUsersControllerMergeMutationError = ErrorType<
  | DashboardUsersControllerMerge400
  | DashboardUsersControllerMerge401
  | DashboardUsersControllerMerge403
  | DashboardUsersControllerMerge404
  | DashboardUsersControllerMerge409
  | DashboardUsersControllerMerge429
>;

/**
 * @summary Merge two users (dashboard)
 */
export const useDashboardUsersControllerMerge = <
  TError = ErrorType<
    | DashboardUsersControllerMerge400
    | DashboardUsersControllerMerge401
    | DashboardUsersControllerMerge403
    | DashboardUsersControllerMerge404
    | DashboardUsersControllerMerge409
    | DashboardUsersControllerMerge429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardUsersControllerMerge>>,
    TError,
    { data: BodyType<DashboardMergeUsers> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardUsersControllerMerge>>,
  TError,
  { data: BodyType<DashboardMergeUsers> },
  TContext
> => {
  const mutationOptions = getDashboardUsersControllerMergeMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Slim profile of the authenticated caller. Includes only the fields the dashboard frontend consumes — no PII or large relations.
 * @summary Current user profile (dashboard)
 */
export const dashboardUsersControllerMe = (
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardCurrentUser>(
    { url: `/api/dashboard/v1/users/me`, method: "GET", signal },
    options
  );
};

export const getDashboardUsersControllerMeQueryKey = () => {
  return [`/api/dashboard/v1/users/me`] as const;
};

export const getDashboardUsersControllerMeQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardUsersControllerMe>>,
  TError = ErrorType<
    | DashboardUsersControllerMe400
    | DashboardUsersControllerMe401
    | DashboardUsersControllerMe404
    | DashboardUsersControllerMe429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerMe>>, TError, TData>
  >;
  request?: SecondParameter<typeof restClient>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardUsersControllerMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardUsersControllerMe>>> = ({
    signal,
  }) => dashboardUsersControllerMe(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardUsersControllerMe>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardUsersControllerMeQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardUsersControllerMe>>
>;
export type DashboardUsersControllerMeQueryError = ErrorType<
  | DashboardUsersControllerMe400
  | DashboardUsersControllerMe401
  | DashboardUsersControllerMe404
  | DashboardUsersControllerMe429
>;

export function useDashboardUsersControllerMe<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerMe>>,
  TError = ErrorType<
    | DashboardUsersControllerMe400
    | DashboardUsersControllerMe401
    | DashboardUsersControllerMe404
    | DashboardUsersControllerMe429
  >,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerMe>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof dashboardUsersControllerMe>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof restClient>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardUsersControllerMe<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerMe>>,
  TError = ErrorType<
    | DashboardUsersControllerMe400
    | DashboardUsersControllerMe401
    | DashboardUsersControllerMe404
    | DashboardUsersControllerMe429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerMe>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof dashboardUsersControllerMe>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof restClient>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardUsersControllerMe<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerMe>>,
  TError = ErrorType<
    | DashboardUsersControllerMe400
    | DashboardUsersControllerMe401
    | DashboardUsersControllerMe404
    | DashboardUsersControllerMe429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerMe>>, TError, TData>
  >;
  request?: SecondParameter<typeof restClient>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Current user profile (dashboard)
 */

export function useDashboardUsersControllerMe<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerMe>>,
  TError = ErrorType<
    | DashboardUsersControllerMe400
    | DashboardUsersControllerMe401
    | DashboardUsersControllerMe404
    | DashboardUsersControllerMe429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerMe>>, TError, TData>
  >;
  request?: SecondParameter<typeof restClient>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardUsersControllerMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Streamed CSV / XLSX export of the full filtered set with parity against `GET /users`. No pagination; capped at 100k rows server-side (413 EXPORT_TOO_LARGE). Columns are selectable via the `columns` query param (a subset of `name`, `surname`, `email`, `phone`, `birthDate`, `nation`, `role`, `gender`, `city`, `country`); omit `columns` to export all of them. Output always follows that canonical column order regardless of the order keys are supplied.
 * @summary Export users (dashboard)
 */
export const dashboardUsersControllerExport = (
  params: DashboardUsersControllerExportParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<Blob>(
    { url: `/api/dashboard/v1/users/export`, method: "GET", params, responseType: "blob", signal },
    options
  );
};

export const getDashboardUsersControllerExportQueryKey = (
  params: DashboardUsersControllerExportParams
) => {
  return [`/api/dashboard/v1/users/export`, ...(params ? [params] : [])] as const;
};

export const getDashboardUsersControllerExportQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardUsersControllerExport>>,
  TError = ErrorType<
    | DashboardUsersControllerExport400
    | DashboardUsersControllerExport401
    | DashboardUsersControllerExport413
    | DashboardUsersControllerExport429
  >,
>(
  params: DashboardUsersControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardUsersControllerExportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardUsersControllerExport>>> = ({
    signal,
  }) => dashboardUsersControllerExport(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardUsersControllerExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardUsersControllerExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardUsersControllerExport>>
>;
export type DashboardUsersControllerExportQueryError = ErrorType<
  | DashboardUsersControllerExport400
  | DashboardUsersControllerExport401
  | DashboardUsersControllerExport413
  | DashboardUsersControllerExport429
>;

export function useDashboardUsersControllerExport<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerExport>>,
  TError = ErrorType<
    | DashboardUsersControllerExport400
    | DashboardUsersControllerExport401
    | DashboardUsersControllerExport413
    | DashboardUsersControllerExport429
  >,
>(
  params: DashboardUsersControllerExportParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerExport>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardUsersControllerExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardUsersControllerExport<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerExport>>,
  TError = ErrorType<
    | DashboardUsersControllerExport400
    | DashboardUsersControllerExport401
    | DashboardUsersControllerExport413
    | DashboardUsersControllerExport429
  >,
>(
  params: DashboardUsersControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerExport>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardUsersControllerExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardUsersControllerExport<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerExport>>,
  TError = ErrorType<
    | DashboardUsersControllerExport400
    | DashboardUsersControllerExport401
    | DashboardUsersControllerExport413
    | DashboardUsersControllerExport429
  >,
>(
  params: DashboardUsersControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export users (dashboard)
 */

export function useDashboardUsersControllerExport<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerExport>>,
  TError = ErrorType<
    | DashboardUsersControllerExport400
    | DashboardUsersControllerExport401
    | DashboardUsersControllerExport413
    | DashboardUsersControllerExport429
  >,
>(
  params: DashboardUsersControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardUsersControllerExportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Resolve a single existing user from an exact email (matched case-insensitively). Returns the same slim detail shape as `GET /users/:id`. Unlike `/users/search` this is an exact, single-result lookup for pickers that key off an email the admin already knows (add an existing user to a federation, assign an existing license holder). Scoped identically to the user list / detail: a non-matching — or out-of-scope — email surfaces as 404, so the endpoint cannot be used to probe for users the caller cannot otherwise see.
 * @summary Look up a user by exact email (dashboard)
 */
export const dashboardUsersControllerLookup = (
  params: DashboardUsersControllerLookupParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardUserDetail>(
    { url: `/api/dashboard/v1/users/lookup`, method: "GET", params, signal },
    options
  );
};

export const getDashboardUsersControllerLookupQueryKey = (
  params: DashboardUsersControllerLookupParams
) => {
  return [`/api/dashboard/v1/users/lookup`, ...(params ? [params] : [])] as const;
};

export const getDashboardUsersControllerLookupQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardUsersControllerLookup>>,
  TError = ErrorType<
    | DashboardUsersControllerLookup400
    | DashboardUsersControllerLookup401
    | DashboardUsersControllerLookup404
    | DashboardUsersControllerLookup429
  >,
>(
  params: DashboardUsersControllerLookupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerLookup>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardUsersControllerLookupQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardUsersControllerLookup>>> = ({
    signal,
  }) => dashboardUsersControllerLookup(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardUsersControllerLookup>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardUsersControllerLookupQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardUsersControllerLookup>>
>;
export type DashboardUsersControllerLookupQueryError = ErrorType<
  | DashboardUsersControllerLookup400
  | DashboardUsersControllerLookup401
  | DashboardUsersControllerLookup404
  | DashboardUsersControllerLookup429
>;

export function useDashboardUsersControllerLookup<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerLookup>>,
  TError = ErrorType<
    | DashboardUsersControllerLookup400
    | DashboardUsersControllerLookup401
    | DashboardUsersControllerLookup404
    | DashboardUsersControllerLookup429
  >,
>(
  params: DashboardUsersControllerLookupParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerLookup>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardUsersControllerLookup>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardUsersControllerLookup<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerLookup>>,
  TError = ErrorType<
    | DashboardUsersControllerLookup400
    | DashboardUsersControllerLookup401
    | DashboardUsersControllerLookup404
    | DashboardUsersControllerLookup429
  >,
>(
  params: DashboardUsersControllerLookupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerLookup>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardUsersControllerLookup>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardUsersControllerLookup<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerLookup>>,
  TError = ErrorType<
    | DashboardUsersControllerLookup400
    | DashboardUsersControllerLookup401
    | DashboardUsersControllerLookup404
    | DashboardUsersControllerLookup429
  >,
>(
  params: DashboardUsersControllerLookupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerLookup>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Look up a user by exact email (dashboard)
 */

export function useDashboardUsersControllerLookup<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerLookup>>,
  TError = ErrorType<
    | DashboardUsersControllerLookup400
    | DashboardUsersControllerLookup401
    | DashboardUsersControllerLookup404
    | DashboardUsersControllerLookup429
  >,
>(
  params: DashboardUsersControllerLookupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerLookup>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardUsersControllerLookupQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Slim user detail for the dashboard edit page. Returns the form-facing field subset (general / location), not the full user record. 404 when the user does not exist or is outside the caller's scope.
 * @summary Get user detail (dashboard)
 */
export const dashboardUsersControllerDetail = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardUserDetail>(
    { url: `/api/dashboard/v1/users/${id}`, method: "GET", signal },
    options
  );
};

export const getDashboardUsersControllerDetailQueryKey = (id: string) => {
  return [`/api/dashboard/v1/users/${id}`] as const;
};

export const getDashboardUsersControllerDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardUsersControllerDetail>>,
  TError = ErrorType<
    | DashboardUsersControllerDetail400
    | DashboardUsersControllerDetail401
    | DashboardUsersControllerDetail404
    | DashboardUsersControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardUsersControllerDetailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardUsersControllerDetail>>> = ({
    signal,
  }) => dashboardUsersControllerDetail(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardUsersControllerDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardUsersControllerDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardUsersControllerDetail>>
>;
export type DashboardUsersControllerDetailQueryError = ErrorType<
  | DashboardUsersControllerDetail400
  | DashboardUsersControllerDetail401
  | DashboardUsersControllerDetail404
  | DashboardUsersControllerDetail429
>;

export function useDashboardUsersControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerDetail>>,
  TError = ErrorType<
    | DashboardUsersControllerDetail400
    | DashboardUsersControllerDetail401
    | DashboardUsersControllerDetail404
    | DashboardUsersControllerDetail429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerDetail>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardUsersControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardUsersControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerDetail>>,
  TError = ErrorType<
    | DashboardUsersControllerDetail400
    | DashboardUsersControllerDetail401
    | DashboardUsersControllerDetail404
    | DashboardUsersControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerDetail>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardUsersControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardUsersControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerDetail>>,
  TError = ErrorType<
    | DashboardUsersControllerDetail400
    | DashboardUsersControllerDetail401
    | DashboardUsersControllerDetail404
    | DashboardUsersControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get user detail (dashboard)
 */

export function useDashboardUsersControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardUsersControllerDetail>>,
  TError = ErrorType<
    | DashboardUsersControllerDetail400
    | DashboardUsersControllerDetail401
    | DashboardUsersControllerDetail404
    | DashboardUsersControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardUsersControllerDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardUsersControllerDetailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Partial update of an existing user. Send only the fields a given form tab owns; absent fields are left untouched. Explicit null clears the corresponding column. `email` is accepted (globally unique — a collision yields 409 EMAIL_ALREADY_IN_USE) but is not nullable. Federation membership and signup source are not accepted here — use the dedicated endpoints. Pass `password` to replace the password in the same request (separate audit-log entry). Audit-log attribution is entity-owned: one row is written per (platform, federation) pair the user belongs to (see `UsersUpdateService.update`) — the caller's platform plays no part in it.
 * @summary Update user (dashboard)
 */
export const dashboardUsersControllerUpdate = (
  id: string,
  dashboardUpdateUser: BodyType<DashboardUpdateUser>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardUserDetail>(
    {
      url: `/api/dashboard/v1/users/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardUpdateUser,
    },
    options
  );
};

export const getDashboardUsersControllerUpdateMutationOptions = <
  TError = ErrorType<
    | DashboardUsersControllerUpdate400
    | DashboardUsersControllerUpdate401
    | DashboardUsersControllerUpdate404
    | DashboardUsersControllerUpdate409
    | DashboardUsersControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardUsersControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdateUser> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardUsersControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdateUser> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardUsersControllerUpdate>>,
    { id: string; data: BodyType<DashboardUpdateUser> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardUsersControllerUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardUsersControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardUsersControllerUpdate>>
>;
export type DashboardUsersControllerUpdateMutationBody = BodyType<DashboardUpdateUser>;
export type DashboardUsersControllerUpdateMutationError = ErrorType<
  | DashboardUsersControllerUpdate400
  | DashboardUsersControllerUpdate401
  | DashboardUsersControllerUpdate404
  | DashboardUsersControllerUpdate409
  | DashboardUsersControllerUpdate429
>;

/**
 * @summary Update user (dashboard)
 */
export const useDashboardUsersControllerUpdate = <
  TError = ErrorType<
    | DashboardUsersControllerUpdate400
    | DashboardUsersControllerUpdate401
    | DashboardUsersControllerUpdate404
    | DashboardUsersControllerUpdate409
    | DashboardUsersControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardUsersControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdateUser> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardUsersControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdateUser> },
  TContext
> => {
  const mutationOptions = getDashboardUsersControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Attach a user to a federation under the current platform (`platformId` in the body). Idempotent — re-adding an existing membership is a no-op and still returns 200 with the current user detail. Records both the flat `user_federations` link and the `(user, federation, platform)` pivot. The caller must have access to both the user and the target federation, and the federation must belong to `platformId`; admin / superAdmin bypass the federation check.
 * @summary Add user to federation (dashboard)
 */
export const dashboardUsersControllerAddToFederation = (
  id: string,
  federationId: string,
  dashboardAddUserToFederation: BodyType<DashboardAddUserToFederation>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardUserDetail>(
    {
      url: `/api/dashboard/v1/users/${id}/federations/${federationId}`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardAddUserToFederation,
      signal,
    },
    options
  );
};

export const getDashboardUsersControllerAddToFederationMutationOptions = <
  TError = ErrorType<
    | DashboardUsersControllerAddToFederation400
    | DashboardUsersControllerAddToFederation401
    | DashboardUsersControllerAddToFederation403
    | DashboardUsersControllerAddToFederation404
    | DashboardUsersControllerAddToFederation429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardUsersControllerAddToFederation>>,
    TError,
    { id: string; federationId: string; data: BodyType<DashboardAddUserToFederation> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardUsersControllerAddToFederation>>,
  TError,
  { id: string; federationId: string; data: BodyType<DashboardAddUserToFederation> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardUsersControllerAddToFederation>>,
    { id: string; federationId: string; data: BodyType<DashboardAddUserToFederation> }
  > = (props) => {
    const { id, federationId, data } = props ?? {};

    return dashboardUsersControllerAddToFederation(id, federationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardUsersControllerAddToFederationMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardUsersControllerAddToFederation>>
>;
export type DashboardUsersControllerAddToFederationMutationBody =
  BodyType<DashboardAddUserToFederation>;
export type DashboardUsersControllerAddToFederationMutationError = ErrorType<
  | DashboardUsersControllerAddToFederation400
  | DashboardUsersControllerAddToFederation401
  | DashboardUsersControllerAddToFederation403
  | DashboardUsersControllerAddToFederation404
  | DashboardUsersControllerAddToFederation429
>;

/**
 * @summary Add user to federation (dashboard)
 */
export const useDashboardUsersControllerAddToFederation = <
  TError = ErrorType<
    | DashboardUsersControllerAddToFederation400
    | DashboardUsersControllerAddToFederation401
    | DashboardUsersControllerAddToFederation403
    | DashboardUsersControllerAddToFederation404
    | DashboardUsersControllerAddToFederation429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardUsersControllerAddToFederation>>,
    TError,
    { id: string; federationId: string; data: BodyType<DashboardAddUserToFederation> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardUsersControllerAddToFederation>>,
  TError,
  { id: string; federationId: string; data: BodyType<DashboardAddUserToFederation> },
  TContext
> => {
  const mutationOptions = getDashboardUsersControllerAddToFederationMutationOptions(options);

  return useMutation(mutationOptions);
};
